module.exports = __webpack_public_path__ + "media/components/country-flag/static/to-1f85ad47d39d65fa85ff96b3bba89672.svg";